<div class="navbar-area">
    <div class="row">
        <div class="col-10">
            <div class="fiwan-responsive-nav">
                <div class="container">
                    <div class="fiwan-responsive-menu">
                        <div class="logo">
                            <a routerLink="/"><img src="assets/img/TamronLogo.jpg" alt="logo"></a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="fiwan-nav">
                <div class="container-fluid">
                    <nav class="navbar navbar-expand-md navbar-light">
                        <a class="navbar-brand" routerLink="/"><img src="assets/img/TamronLogo.jpg" alt="logo"
                                style="width: 200px;"></a>
                        <div class="collapse navbar-collapse mean-menu">
                            <ul class="navbar-nav">
                                <li class="nav-item"><a routerLink="/" class="nav-link" routerLinkActive="active" style="padding-top: 30px;"
                                        [routerLinkActiveOptions]="{exact: true}">Home</a>
                                </li>

                                <li class="nav-item"><a routerLink="/all-products" class="nav-link"
                                        routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Products</a>
                                </li>

                                <li class="nav-item"><a routerLink="/news" class="nav-link" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{exact: true}">News</a>
                                </li>
                                 <li class="nav-item"><a routerLink="/posts" class="nav-link" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{exact: true}">Posts</a>
                                </li>

                                <li class="nav-item"><a routerLink="/contact" class="nav-link" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{exact: true}">Contact Us</a></li>
                                <li class="nav-item"><a routerLink="/search" class="nav-link" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{exact: true}"
                                        style="color: rgb(74, 174, 241);">Search</a></li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
        <div class="col-2">
            <div class="others-option d-flex align-items-center" style="padding-left: 5px;padding-top: 20px;">
                <div class="option-item">
                    <img src="assets/img/flag/us.jpg" class="shadow" alt="image">
                    <span> Sri Lanka </span>
                </div>
            </div>
        </div>
    </div>



</div>
<!-- End Navbar Area -->

<!-- Search Overlay -->
<!--div class="search-overlay" [class.active]="isSearchOverlayVisible">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="search-overlay-close" (click)="closeSearchOverlay()">
                <span class="search-overlay-close-line" style="background-color: black;"></span>
                <span class="search-overlay-close-line" style="background-color: black;"></span>
            </div>
            <div class="search-overlay-form" >
                <form>
                    <input type="text" class="input-search" placeholder="Search here..." name="search_value" [(ngModel)]="searchValue" style="background-color: blue;">
                    <button type="submit" [routerLink]="['/search-product', searchValue]" (click)="toggleSearchOverlay();"><i class='bx bx-search'></i></button>
                    
                    
                </form>
                
                
            </div>
        </div>
    </div>
</div-->
<!-- End Search Overlay  [routerLink]="['/search-product', searchValue]" -->